import { get } from 'config/api/config';

import {
  getLaunchDiagnosticQuery,
  getLaunchHttpStatus,
  recordLaunchFailure,
} from 'utils/launchDiagnostics';
import type { ViewerLaunchContextPayload } from 'utils/viewerLaunchContextSession';

/**
 * Fetches launch payload from Form Builder API (row created by POST /v1/viewer/launch).
 * Returns null on 204 or error — caller should fall back to URL-only flow.
 */
export async function fetchViewerLaunchContext(
  launchContextId: string,
): Promise<ViewerLaunchContextPayload | null> {
  if (!launchContextId.trim()) {
    return null;
  }
  const startedAt = Date.now();
  try {
    const res = await get<ViewerLaunchContextPayload>('/viewer/launch-context', {
      params: {
        launchContextId: launchContextId.trim(),
        ...getLaunchDiagnosticQuery(),
      },
    });
    if (res.status === 204) {
      return null;
    }
    if (res.status === 200 && res.data && typeof res.data === 'object') {
      return res.data;
    }
    recordLaunchFailure('launch_context', {
      httpStatus: res.status,
      durationMs: Date.now() - startedAt,
    });
    return null;
  } catch (error) {
    recordLaunchFailure('launch_context', {
      durationMs: Date.now() - startedAt,
      httpStatus: getLaunchHttpStatus(error),
    });
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[viewer-launch] fetchViewerLaunchContext failed');
    }
    return null;
  }
}
